import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import useSlug from '../utils/router/useSlug';

const TOPIC_ANCESTORS_QUERY = gql(/** @complexity 3 */ `
  query usePublicAncestorsTopicQuery($id: ID!) {
    publicTopic(id: $id) {
      id
      ancestors {
        id
      }
    }
  }
`);

const POST_ANCESTORS_QUERY = gql(/** @complexity 7 */ `
  query usePublicAncestorsPostQuery($id: ID!) {
    publicPost(id: $id) {
      id
      topics {
        id
        ancestors {
          id
        }
      }
    }
  }
`);

const EMPTY_SET = new Set<string>();

export default function usePublicAncestors(): Set<string> {
  const [postId] = useSlug('postSlug');
  const [topicId] = useSlug('topicSlug');

  const { data: postData } = useQuery(POST_ANCESTORS_QUERY, {
    variables: { id: postId },
    skip: !postId,
    fetchPolicy: 'cache-first',
  });

  const { data: topicData } = useQuery(TOPIC_ANCESTORS_QUERY, {
    variables: { id: topicId },
    skip: !topicId,
    fetchPolicy: 'cache-first',
  });

  if (postData) {
    return new Set(
      postData.publicPost.topics.flatMap((topic) => [
        topic.id,
        ...topic.ancestors.map((ancestor) => ancestor.id),
      ]),
    );
  }

  if (topicData) {
    return new Set([
      topicData.publicTopic.id,
      ...topicData.publicTopic.ancestors.map((ancestor) => ancestor.id),
    ]);
  }

  return EMPTY_SET;
}
